export const titleTxt = "Desktop only"
export const subtitleTxt = "Head to your computer and show\nthe Gods their due respect"